<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import URL from '@/api/im/url'
  import Qs from 'qs'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "delete"){
          this.dataChanage(URL.call.customerTest.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.customerTest.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '用户账号', field: 'customerNumber',required:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              {click:"查询"},
              {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.customerTest.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '用户账号', field: 'customerNumber'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '创建人', field: 'creator'},
              {field:"删除",title:"操作",size:"mini",click:"delete",type:"primary",icon:"el-icon-update"}
          ]
        }
      }
    }
  }
</script>
